import {BaseDTO} from './base-dto';


export class NotificationMinute extends BaseDTO{

    Seen: boolean;
    Message: string;
    ExpiredAt: string;
    CreatedAt: string;
    Subject: string;
    Link: string;
}
